export default "__VITE_ASSET__BFFdFRat__"